import { useI18n } from 'vue-i18n'
import { PATRIMONY_COLORS, PATRIMONY_COLORS_DARK } from '@/assets/constants/core'
/** returns patrimony info
@return { Object }
*/
export const getAllPatrimonyInfo = state => state.patrimonyInfo

/** returns patrimony back state
@return { Object }
*/
export const getPatrimonyBackState = state => {
    return state.savedBackStateInfo
}

/** returns patrimony accounts currencies List
@return { Array }
*/
export const getAccountsCurrenciesList = state => {
    return state.patrimonyInfo.currenciesFromAccounts
}

/** returns patrimony accounts products List
@currency { String }
@return { Array }
*/
export const getAccountsProductsList = state => (currency, appMode) => {
    const products = state.patrimonyInfo.accountTypes.map((product, index) => {
        return {
            ...product,
            color: appMode === 'dark' ? PATRIMONY_COLORS_DARK[index] : PATRIMONY_COLORS[index]
        }
    })

    if (!currency || currency === 'allCurrencies') return products

    /* If we are filtering by currency we need to validate which accounts have them, and which type they are */
    const accounts = state.patrimonyInfo.accounts.filter(account => account.accountCurrency === currency)

    const newProducts = products.reduce((acc, product) => {
        if (accounts.find(account => account.accountType === product.id)) acc.push(product)
        return acc
    }, [])

    return newProducts
}

/**
* creating list of accounts based on received params
@currency { String }
@product { String }
@assetOrLiability { String }
*/
export const getPatrimonyAccountsList = state => (currency, product, assetOrLiability) => {
    // we will add a prop named description to account, to match product params named
    let accounts = state.patrimonyInfo.accounts.map(account => {
        return {
            ...account,
            description: account.accountDescription
        }
    })

    if (currency) accounts = accounts.filter(obj => obj.accountCurrency === currency)
    if (product && product !== 'allProducts') accounts = accounts.filter(obj => obj.accountType === product)
    if (assetOrLiability) accounts = accounts.filter(obj => obj.accountFinancialType === (assetOrLiability === 'assets' ? 'ASSET' : 'LIABILITY'))

    return accounts
}

/*
* Parsing info provided to match dropdown obj params
*/
export const getCurrenciesList = state => {
    const { t } = useI18n()

    const currenciesDropList = state.patrimonyInfo.currenciesFromAccounts.map(currency => {
        return {
            ...currency,
            currency: currency.name
        }
    })

    if (currenciesDropList.length === 1) {
        currenciesDropList[0].isSelected = true
    } else {
        currenciesDropList.unshift({ currency: 'allCurrencies', description: t('accounts.patrimony.labels.allCurrencies'), isSelected: true })
    }

    return currenciesDropList
}
